import { safeStorage } from './safariStorage';

const NATIVE_ROLE_PREFERENCE_KEY = 'godyspo_native_role_preference';

export type NativeRolePreference = 'buyer' | 'seller';

export const getNativeRolePreference = (): NativeRolePreference | null => {
  const value = safeStorage.getItem(NATIVE_ROLE_PREFERENCE_KEY);
  if (value === 'buyer' || value === 'seller') return value;
  return null;
};

export const setNativeRolePreference = (role: NativeRolePreference): void => {
  safeStorage.setItem(NATIVE_ROLE_PREFERENCE_KEY, role);
};

export const clearNativeRolePreference = (): void => {
  safeStorage.removeItem(NATIVE_ROLE_PREFERENCE_KEY);
};
